export type TEnvironment = 'production' | 'staging' | 'demo' | 'dev' | 'unknown';

export const getEnvironmentFromHostname = (hostname: string): TEnvironment => {
  if (hostname === 'autoscript.ai' || hostname === 'www.autoscript.ai') {
    return 'production';
  }

  if (hostname === 'staging.autoscript.ai') {
    return 'staging';
  }

  if (hostname === 'demo.autoscript.ai') {
    return 'demo';
  }

  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === 'mac.local' ||
    hostname.endsWith('.ts.net')
  ) {
    return 'dev';
  }

  return 'unknown';
};
